import React from "react";

const features = [
  {
    title: "Analyse IA B2B",
    description:
      "Mesurez, analysez et comparez vos performances LinkedIn grâce à une IA avancée dédiée au B2B.",
    image: "/assets/images/cards/image-01.jpg",
    alt: "IA B2B",
  },
  {
    title: "Recommandations intelligentes",
    description:
      "Augmentez la portée et l'engagement grâce à des recommandations sur le contenu, le timing et les hashtags.",
    image: "/assets/images/cards/image-02.jpg",
    alt: "Stratégie hashtags",
  },
  {
    title: "Pilotage stratégique",
    description:
      "Profitez de l’accompagnement de nos experts pour définir vos KPI, piloter vos campagnes et maximiser votre ROI.",
    image: "/assets/images/cards/image-03.jpg",
    alt: "Pilotage KPI",
  },
];

const FeaturesCards = () => {
  return (
    <section className="bg-white py-20 lg:py-[120px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          {features.map((item, index) => (
            <div
              key={index}
              className="w-full px-4 md:w-1/2 xl:w-1/3"
            >
              <div className="mb-10 rounded-lg bg-white shadow-md hover:shadow-lg transition duration-300 flex flex-col h-full">
                <div className="w-full aspect-[3/2] overflow-hidden rounded-t-lg">
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 text-center flex-grow flex flex-col justify-between">
                  <h3 className="mb-3 text-xl font-semibold text-dark">
                    {item.title}
                  </h3>
                  <p className="text-base text-body-color leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesCards;
